// Lib
import { createAction } from 'redux-actions';

export const SetMarbleUser = createAction('SET_MARBLE_USER');
export const UserLogout = createAction('MARBLE_USER_LOGOUT');
export const UserSignIn = createAction('MARBLE_USER_SIGN_IN');
export const UserSignUp = createAction('MARBLE_USER_SIGN_UP');
export const UserPasswordReset = createAction('MARBLE_USER_PASSWORD_RESET');
export const UserSignInWithGoogle = createAction(
  'MARBLE_USER_SIGN_IN_WITH_GOOGLE',
);
export const UserEmailVerification = createAction('USER_EMAIL_VERIFICATION');
export const UserEmailTempVerification = createAction(
  'USER_EMAIL_TEMP_VERIFICATION',
);

export const UpdatedMarbleUser = createAction('UPDATE_MARBLE_USER');
export const UpdatedMarbleUserAuths = createAction('UPDATE_MARBLE_USER_AUTHS');
export const ChangeUsername = createAction('MARBLE_USER_CHANGE_USERNAME');
export const PassUserOnboarding = createAction('MARBLE_USER_PASS_ONBOARDING');

export const UpdateLink = createAction('UPDATE_LINK');
export const CreateLink = createAction('CREATE_LINK');
export const DeleteLink = createAction('DELETE_LINK');
export const AddLinks = createAction('ADD_LINKS');

export const UserLogoutFromApp = createAction('MARBLE_USER_LOGOUT_FROM_APP');

export const UserDataLoad = createAction('MARBLE_USER_DATA_LOAD');
export const UserDataLoaded = createAction('MARBLE_USER_DATA_LOADED');

export const UserGetAccountById = createAction('MARBLE_USER_GET_ACCOUNT_BY_ID');
export const UserUpdate = createAction('MARBLE_USER_UPDATE');
export const UserAdd = createAction('MARBLE_USER_ADD');
export const UserError = createAction('MARBLE_USER_ERROR');

export const GetUserAnalytics = createAction('GET_MARBLE_USER_ANALYTICS');
export const SetUserAnalytics = createAction('SET_MARBLE_USER_ANALYTICS');

export const UpdateAuths = createAction('UPDATE_AUTHS');
export const SetAuth = createAction('SET_AUTH');

export const SetSlidesLoading = createAction('SET_SLIDES_LOADING');
export const UpdateSlides = createAction('UPDATE_SLIDES');
export const DeleteSlides = createAction('DELETE_SLIDES');
export const ClearSlides = createAction('CLEAR_SLIDES');
export const SaveSlides = createAction('SAVE_SLIDES');

export const UpdateBackgroundSettings = createAction(
  'UPDATE_BACKGROUND_SETTINGS',
);

export const GetSubscriptionsStatus = createAction('GET_SUBSCRIPTIONS_STATUS');
export const SetSubscriptionsStatus = createAction('SET_SUBSCRIPTIONS_STATUS');
export const SetAccountTooltips = createAction('SET_ACCOUNT_TOOLTIPS');

export const SetTheme = createAction('SET_THEME');
export const UpdateTheme = createAction('UPDATE_THEME');
export const UpdateMarkup = createAction('UPDATE_MARKUP');
export const SetMarkup = createAction('SET_MARKUP');
export const UpdateAdvancedColor = createAction('UPDATE_ADVANCED_COLOR');

export const SaveAccountDetails = createAction('SAVE_ACCOUNT_DETAILS');

export const SetDataCollectionSettings = createAction(
  'SET_DATA_COLLECTION_SETTINGS',
);

export const UpdateAuthsStatus = createAction('UPDATE_AUTHS_STATUS');

export const UpdateAmbasador = createAction('UPDATE_AMBASADOR');
// export const UpdatePartners = createAction('UPDATE_PARTNERS');

export const UpdateUserTheme = createAction('UPDATE_USER_THEME');
